var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockAccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-290.9 657.2 612 611.9",
    enableBackground: "new -290.9 657.2 612 611.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-259.4,857.4c-17.4,0-31.5-14.1-31.5-31.5v-68.6c0-55.2,44.9-100.1,100.1-100.1h68.6c17.4,0,31.5,14.1,31.5,31.5 c0,17.4-14.1,31.5-31.5,31.5h-68.6c-20.4,0-37.1,16.7-37.1,37.1v68.6C-227.9,843.3-241.9,857.4-259.4,857.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-122.1,1269.1h-68.6c-55.2,0-100.1-44.9-100.1-100.1v-68.6c0-17.4,14.1-31.5,31.5-31.5s31.5,14.1,31.5,31.5v68.6 c0,20.4,16.7,37.1,37.1,37.1h68.6c17.4,0,31.5,14.1,31.5,31.5C-90.6,1255-104.7,1269.1-122.1,1269.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M289.6,857.4c-17.4,0-31.5-14.1-31.5-31.5v-68.6c0-20.4-16.7-37.1-37.1-37.1h-68.6c-17.4,0-31.5-14.1-31.5-31.5 c0-17.4,14.1-31.5,31.5-31.5H221c55.2,0,100.1,44.9,100.1,100.1v68.6C321.1,843.3,307,857.4,289.6,857.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M221,1269.1h-68.6c-17.4,0-31.5-14.1-31.5-31.5c0-17.4,14.1-31.5,31.5-31.5H221c20.4,0,37.1-16.7,37.1-37.1v-68.6 c0-17.4,14.1-31.5,31.5-31.5s31.5,14.1,31.5,31.5v68.6C321.1,1224.2,276.2,1269.1,221,1269.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118,1131.8H-87.8c-38.2,0-65.8-27.6-65.8-65.8V963.1c0-38.2,27.6-65.8,65.8-65.8h205.9c38.2,0,65.8,27.6,65.8,65.8V1066 C183.8,1104.2,156.2,1131.8,118,1131.8z M-90.3,1068.5c0.5,0.1,1.3,0.3,2.5,0.3h205.9c1.3,0,2.1-0.2,2.5-0.3 c0.1-0.5,0.3-1.3,0.3-2.5V963.1c0-1.3-0.2-2.1-0.3-2.5c-0.5-0.1-1.3-0.3-2.5-0.3H-87.8c-1.3,0-2.1,0.2-2.5,0.3 c-0.1,0.5-0.3,1.3-0.3,2.5V1066C-90.6,1067.3-90.5,1068.1-90.3,1068.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.6,873v-57.8c0-20.5,16.7-37.1,37.1-37.1c20.4,0,37.1,16.7,37.1,37.1V873h63v-57.8c0-55.2-44.9-100.1-100.1-100.1 S-86.6,760-86.6,815.2V873H-23.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockAccess);
export default __webpack_public_path__ + "static/media/lock-access.cd18265f.svg";
export { ForwardRef as ReactComponent };